<template>
    <div>
        <input :id="id" :placeholder="placeholder" class="input" v-model="inputValue" @keypress.enter="eventEnter"  :disabled="disabled">
    </div>
</template>

<script>

export default {
    components: {

    },
    name: 'FormInput',
    props: {
        id: String,
        placeholder: {
            type: String,
            default() {
            return this.$store.getters.t('동영상 제목 또는 태그로 동영상 찾기');
            }
        },
        value: String,
        handleEnter: Function,
        viewType: String,
        disabled: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        eventEnter(){
            if(this.viewType === 'tag'){
                this.handleEnter(this.inputValue);
            }
        }
    },
    data() {
        return {
            inputValueInternal: ''
        };
    },
    computed: {
        inputValue: {
            get() {
                return this.inputValueInternal;
            },
            set(value) {
                this.$emit('input', value, this.viewType);
                this.inputValueInternal = value;
                // console.log("this => ", this.inputValueInternal)
            }
        }
    },
    watch: {
        value(newValue) {
            this.inputValueInternal = newValue;
        }
    },
};
</script>

<style scoped>
.input {
    width: 100%;
    height: 36px;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 14px;
    background: #fff;
}

input:focus {
    outline: none;
    border: 1px solid #999;
}
</style>